// extracted by mini-css-extract-plugin
module.exports = {"portfolio":"HomePortfolio_portfolio__33VGU","card":"HomePortfolio_card__iCHB-"};